class JoinStore {
	constructor() {
		this.state = {
			agreement1: false,
			agreement2: false
		};

		this.mutations = {
			setAgreement1(state, payload) {
				state.join.agreement1 = payload;
			},
			setAgreement2(state, payload) {
				state.join.agreement2 = payload;
			}
		};

		this.getters = {
            
		};

		this.actions = {
            
		};
	}
}

export default new JoinStore();